import { Routes } from './Routes';

function buildRouteWithQueryParams(
  route: Routes,
  params: Record<string, string>
): string {
  const queryString = new URLSearchParams(params).toString();
  return `${route}?${queryString}`;
}

export default buildRouteWithQueryParams;
